import { useEffect, useState } from 'react'

export const useWindow = (): Window => {
  const [w, setW] = useState<Window>()

  useEffect(() => {
    setW(window)
  }, [])

  return w
}
